import type { CSSProperties, ReactNode } from 'react';
import { Steve } from '../../components/Steve';
import styles from './wiki.module.css';

interface Props {
  /** 0,66 dans l'infobox, 0,42 en vignette de section. */
  readonly scale: number;
  readonly caption: string;
}

/**
 * Le Steve du site, posé comme une image téléversée.
 *
 * **Il n'est pas réimplémenté** : c'est le dessin CSS commun aux dix skins, dont
 * l'anatomie est spécifiée pièce par pièce dans le handoff global. Ici il est
 * simplement figé — pas de flottement — et encadré d'un filet d'un pixel sur
 * fond blanc, comme n'importe quelle illustration d'article.
 *
 * Le figement passe par une durée de flottement nulle plutôt que par un
 * `animation: none` posé de l'extérieur : le composant `Steve` place lui-même
 * son animation, et une règle du skin qui la couperait serait un couplage de
 * plus entre deux fichiers qui n'ont pas à se connaître.
 *
 * La boîte extérieure porte la taille finale, la boîte intérieure garde les
 * 300 × 210 d'origine et se met à l'échelle : mettre le `scale` sur le dessin
 * lui-même écraserait la transform de l'animation.
 */
export function WikiSteve({ scale, caption }: Props): ReactNode {
  const box = {
    width: `${String(Math.round(300 * scale))}px`,
    height: `${String(Math.round(210 * scale))}px`,
  } as CSSProperties;
  const inner = { transform: `scale(${String(scale)})` } as CSSProperties;

  return (
    <figure className={styles.figure}>
      <div className={styles.imageFrame}>
        <div className={styles.imageBox} style={box} aria-hidden="true">
          <div className={styles.imageScale} style={inner}>
            <Steve bobDuration="0s" />
          </div>
        </div>
      </div>
      <figcaption className={styles.caption}>{caption}</figcaption>
    </figure>
  );
}
